<template>
  <div class="basic-block block-about-fortune-base" :style="styles">
    <img v-if="targetInfo.fortune.castle" :src="targetInfo.fortune.castle" class="block-about-fortune-base__deco" alt="">
    <div class="content-wrap">
      <div class="block-about-fortune-base__inner">
        <lp-title title="宇宙占術RPUとは" :color-scheme="colorScheme" alphabet="fortune-telling" />
        <img class="desc-image" src="/static/img/recommend/lp/ottimo/about_rpu_image.png" alt="">
        <div class="btn-wrap">
          <div class="mess" v-html="message"></div>
          <lp-base-button
            :label="label"
            design="fill"
            :color-scheme="colorScheme"
            @clicked="onBtnClick"
            class="btn-free-shindan"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LpTitle from '@/utvStore/components/recommend/lp/partials/LpTitle'
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'
import BlockBanner from '@/utvStore/components/recommend/lp/blocks/BlockBanner'
import LineCampaignMessage from '@/utvStore/components/recommend/lp/partials/LineCampaignMessage'

export default {
  name: 'BlockAboutFortune',
  components: {
    LpTitle,
    LpBaseButton,
    BlockBanner,
    LineCampaignMessage
  },
  props: {
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    lpId: {
      type: Number,
      default: 1,
    },
    bannerType: {
      type: String,
      default: 'LINE',
    },
    page: {
      type: String,
      default: '',
    },
    subscUrl: String,
  },
  data() {
    return {
      message: '宇宙占術ＲＰＵを<br>体験してみませんか？',
      label: '<span>▶︎</span>無料で占う',
    }
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
  created() {
    if (this.page == 'basicresult') {
      this.message = 'これから待ち受ける<br>色々な自分の運命を<br>占ってみませんか？'
      this.label = '<span>▶︎</span>占い放題に登録'
    }
  },
  methods: {
    onBtnClick() {
      if (this.page == 'basicresult') {
        window.gtag('event', 'click', {
          'event_category': `LP${this.lpId}${this.page}-subsc-button`,
          'event_label': 'point5',
        })
        location.href = this.$handoverParams(this.subscUrl)
      } else {
        window.gtag('event', 'click', {
          'event_category': `LP${this.lpId}-free-shindan-button`,
          'event_label': 'middle',
        })
        location.href = this.$handoverParams(`/recommend/lp/${this.lpId}/basic/input`)
      }
    },
  },
}</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-about-fortune-base {
  background: #feffe0;
  padding: 48px 0 0;
  &__deco {
    position: absolute;
    top: -46px;
    right: 16px;
    width: 23.5%;
    max-width: 80px;
    z-index: 2;
  }
  &__inner {
    padding: 0 20px;
    @include mq('w580') {
      padding: 0 40px;
    }
    img {
      display: block;
      width: 100%;
      margin-bottom: 24px;
      @include mq('w580'){
        margin-bottom: 40px;
      }
    }
  }
  .block-title {
    /deep/ span {
      display: none;
    }
    &::before {
      content: "";
      display: inline-block;
      width: 233px;
      height: 1.2em;
      background: url(/static/img/recommend/lp/ottimo/head_about_rpu.png) no-repeat center center;
      background-size: 100% auto;
    }
  }
  .btn-wrap {
    padding: 0 16px 60px;
    .mess {
      font-size: 20px;
      font-weight: bold;
      line-height: 28px;
      text-align: center;
      color: $l_col_keycolor;
      margin-bottom: 24px;
      @include mq('w580'){
        font-size: 26px;
        line-height: 38px;
        margin-bottom: 40px;
      }
    }
    .btn-free-shindan {
      max-width: 372px;
      margin: 0 auto;
      /deep/ {
        .baseButton__button {
          filter: drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.25));
          display: flex;
          justify-content: center;
          align-items: center;
          height: 60px;
          &__label {
            font-size: 22px;
            span {
              margin-right: 16px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/ottimo/blocks/BlockAboutFortune2.vue